import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Button, HStack, Icon, Stack, Text } from "@chakra-ui/react";

import { BankCardIcon } from "../../../../../icons";
import { RoutesMap } from "../../../../../../routes.tsx";
import { ICard } from "../../../../../../api/cards/types.ts";
import { getPaymentMethodName } from "../../../../../../utils";

interface Props {
  isPending: boolean;
  hideModal: () => void;
  paymentMethod: ICard;
}

export const PaymentModalPaymentMethod: FC<Props> = ({ isPending, hideModal, paymentMethod }) => {
  const navigate = useNavigate();

  const paymentMethodName = getPaymentMethodName(paymentMethod);

  const onChangePaymentMethod = () => {
    if (!isPending) {
      hideModal();
      navigate(RoutesMap.cards.index);
    }
  };

  return (
    <Stack spacing="1px" mb="18px">
      <Text variant="gray" fontSize="12px">Способ оплаты</Text>

      <HStack h="25px" justifyContent="space-between">
        <HStack>
          <Icon as={BankCardIcon} boxSize="24px" color="brand.500" />
          <Text variant="brand">{paymentMethodName}</Text>
        </HStack>

        <Button p={0} mt="2px" colorScheme="transparent" onClick={onChangePaymentMethod}>
          <Text variant="brand">Изменить</Text>
        </Button>
      </HStack>
    </Stack>
  );
};
